module.exports = __webpack_public_path__ + "img/kia-spectra-2008.b5aa1846.jpg";